import _ from 'lodash';

export default class Model {
	constructor (data) {
		this.set(data);
	}

	get (key, defaultValue = null) {
		return _.get(this, key, defaultValue);
	}

	set (key, value) {

		if (arguments.length === 1) {

			if (typeof key === 'object') {

				const data = key;

				// Assign the data values to the object
				for (let key in data) {
					this[key] = data[key];
				}
			}

		} else {
			this[key] = value;
		}

		return this;
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/models/model.js